<template>
  <div :class="['bottom-switch','lives-type',centerStyle?centerStyle:'']"
        @mouseenter="arrowRiightShow = true" @mouseleave="arrowRiightShow = false"
       :style="{padding:(centerStyle=='flowArchShow'?'18px 20px':'')}">
    
    <div class="bottom-content swiper-containerOut"
         :style="{height:`${baseHeight}px`}"
         ref="rightContent"
         :class="['bottom-content'+ swiperInd + indexs]">
      <ul class="clearfix swiper-wrapperOut">
        <template v-for="(items,ind) in tagsDataList">
          <li :class="['fl', 'swiper-slideOut']" draggable="true" @dragstart="dragss($event,items)"
              v-for="(item,inds) in items.standList"
              :key="'ll'+ind+'-'+inds"
              @click.stop.prevent="handleOpenLink(item)"
              @contextmenu.stop.prevent="items.standAllName?$emit('emitContextMenuItem',ind,$event,items.standAllName):''"
              @touchstart="touchstarts(ind,$event,items.standAllName)"
              @touchmove="touchmoves()"
              @touchend="touchends()">
            <special-offer :ite="items" @removeCon="removeCon" v-show="seckillShow"></special-offer>
            <a href="javascript:;"
               v-if="item.type=='lives'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :slotIcon="item.data?false:true"
                      :value="item.data?item.data:''"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_live_online_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='videos'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :slotIcon="item.data?false:true"
                      :value="item.image?item.image:item.data"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_short_video_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
             
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
               <img @click.stop.prevent="openVideo(item.data,items.standAllName)" v-show="item.image" class="li_hover_img" src="../../assets/image/images/wz_play.png" alt="">
            </a>
            <a href="javascript:;"
               v-if="item.type=='images'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_hundred_impression_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='articles'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_today_news_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='files'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_baijia_library_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='cmsknows'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_cm_knows_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='opetrains'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_operation_training_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='aidevices'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_ai_equipment_icon.png'):require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='texts'"
               @click.stop.prevent="$emit('emitHandleDetail',items)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="require('../../assets/image/images/default_media.png')"
                      v-if="!items.iframeUrl" />
              <iframe v-else
                      :src="items.iframeUrl"
                      width="100%"
                      height="88%"
                      frameborder="0"></iframe>
              <div class="li_hover"
                   @click.stop="$emit('emitHandleDetail',items,'newDetail')">
                <p class="li_hover_title">
                  <span>{{items.standAllName?items.standAllName:''}}</span>
                  <span>{{items.appName?items.appName:''}}</span>
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="!isUrl(tag.data) && tag.name != '头像' && tag.standardEnName != 'productMarking' && tag.standardEnName != 'tagline'"
                         class="label-set"
                         v-for="(tag,tin) in filterJCPrice(items.standAllTag)"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}</span>
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
          </li>
        </template>
      </ul>
      <!-- <div :class="['arrow-left','arrow-left'+ swiperInd + indexs]"></div> -->
      <div :class="['arrow-right','arrow-right'+ swiperInd + indexs,{'show':arrowRiightShow}]" :style="IsMobile() ? '' : 'display:none;'"
           @click="$emit('arrowRight')"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import CountDown from "../../components/CountDown.vue";
import ZImage from "../ZImage.vue"
import SpecialOffer from '../../components/specialOffer.vue';
export default {
  name: 'baseGroup',
  components: {
    ZImage,
    CountDown,
    SpecialOffer
  },
  props: {
    checkedItemId: {
      type:Object
    },
    baseHeight: {
      type: Number
    },
    standList: {
      type: Array
    },
    swiperInd: {
      type: String
    },
    preNum: {
      type: Number
    },
    centerStyle: {
      type: String
    },
    tabActiveType: {
      type: String
    },
    indexs: Number
  },
  data () {
    return {
      timeOutEvent: 0,
      tagsDataList: [],
      tagsAllEmpty: true,
      tagsAlowList: [],
      mySwiper1: undefined,
      num: 0,
      seckillShow: true,
      arrowRiightShow:false
    }
  },
  watch: {
    standList: function (val) {
      this.initGroupByType(val);
    }
  },
  mounted () {
    this.initGroupByType(this.standList);
  },
  computed: {
    isPC () {
      if (window.innerWidth > 768 ) {
        return true;
      } else { return false; }
    }
  },
  methods: {
    dragss(ev,items){
      var ipcRender,wzUrl = items&&items.contentWzUrl?items.contentWzUrl :items.contentDsfWzUrl;
      
      if (navigator.userAgent.indexOf('Electron') > -1) {
        ev.preventDefault();
        ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
        ipcRender.send('startdrag',{'id':items.contentId,'fileName':items.standAllName?items.standAllName + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr'):'','url': wzUrl ? wzUrl : location.origin + '/uoqid?appId='+ items.appId +'&blockId='+ items.blockId +'&contentId='+ items.contentId +'&dataType=' + (items.sign ?  items.sign : 1)});
      }else{
        var desk = items.standAllName?items.standAllName:'';
        var text = JSON.stringify({ title: desk, url: wzUrl });  //要保存的内容
        var blob = new Blob([text], { type: "text/plain" });
        var anchor = window.URL.createObjectURL(blob);  //要保存的链接
        // 设置为文件类型
        ev.dataTransfer.setData("DownloadURL", 'text/plain:' + desk + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr') + ':' + anchor);
        ev.dataTransfer.setData("deviceId", JSON.stringify({id:items.contentId,checkedItemId:this.checkedItemId.id,env:location.hostname}));
      }
    },
    //判断右上角秒杀是否显示
    removeCon (ind, show) {
      this.seckillShow = show;
    },
    touchstarts (ind, ev,name) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind, ev,name);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    handleOpenLink (item) {
      // const type = item.type;
      // var url = '';
      // switch(type){
      //     case 'lives':
      //         url = 'https://520emv.com/uoqid/?appId=tpzbzsptgyy'
      //         break;
      //     case 'videos':
      //         url='https://520emv.com/uoqid/?appId=dbsjzsptgyy'
      //         break;
      //     case 'images':
      //         url='https://520emv.com/uoqid/?appId=bjyxzsptgyy'
      //         break;
      //     case 'article':
      //         url='https://520emv.com/uoqid/?appId=jrzxzsptgyy'
      //         break;
      //     case 'files':
      //         url='https://520emv.com/uoqid/?appId=bjwkzsptgyy'
      //         break;
      //     case 'cmsknows':
      //         url='https://520emv.com/uoqid/?appId=zjzdzsptgyy'
      //         break;
      //     case 'opetrains':
      //         url='https://520emv.com/uoqid/?appId=czpxzsptgyy'
      //         break;
      //     case 'aidevices':
      //         url='https://520emv.com/uoqid/?appId=aisbzsptgyy'
      //         break;
      //     default:
      //         url=''
      //         break;
      // }
      // if(url){
      //     this.open(url,'_self');
      // }
    },
    getMapNameByType (fileType) {
      var type = fileType;
      switch (type) {
        case '11':
          type = 'lives';
          break;
        case '1':
          type = 'videos';
          break;
        case '2':
          type = 'images';
          break;
        // case '12':
        //     type = 'gifs';
        //     break;
        case '16':
          type = 'article';
          break;
        case '4':
          type = 'files';
          break;
        case '17':
          type = 'cmsknows';
          break;
        case '15':
          type = 'opetrains';
          break;
        case '13':
          type = 'aidevices';
          break;
        // case '8':
        //     type = 'packages';
        //     break;
        // case '9':
        //     type = 'zips';
        //     break;
        // case '10':
        //     type = 'others';
        //     break;
        default:
          type = 'texts';
          break;
      }
      return type;
    },
    getDefaultBalueByType (fileType) {
      var val;
      switch (fileType) {
        case '11':
          val = require('../../assets/image/images/default_live_online.jpg');
          break;
        case '1':
          val = require('../../assets/image/images/default_short_video.jpg');
          break;
        case '2':
          val = require('../../assets/image/images/default_hundred_impression.png');
          break;
        // case '12':
        //     val = require('../../assets/image/images/default_dongtu.gif');
        //     break;
        case '16':
          val = require('../../assets/image/images/default_today_news.png');
          break;
        case '4':
          val = require('../../assets/image/images/default_baijia_library.png');
          break;
        case '17':
          val = require('../../assets/image/images/default_cm_knows.png');
          break;
        case '15':
          val = require('../../assets/image/images/default_operation_training.png');
          break;
        case '13':
          val = require('../../assets/image/images/default_ai_equipment.png');
          break;
        // case '20':
        //   val = require('../../assets/image/images/defaultImg.png');
        //   break;

        // case '8':
        //     val = '';
        //     break;
        // case '9':
        //     val = '';
        //     break;
        // case '10':
        //     val = '';
        //     break;
        default:
          val = ''
      }
      return val;
    },
    initGroupByType (list) {
      
      const Slist = list.length ? list : [{ standardJson: [] }];
      var allContent = false;

      const tagGrops = Slist.map((stand) => {
        let standItem = {};
        standItem.appId = stand.appId;
        standItem.blockId = stand.blockId;
        standItem.nodeId = stand.nodeId;
        standItem.contentId = stand.contentId;
        standItem.contentRows = stand.contentRows;
        standItem.contentShowFlowPosition = stand.contentShowFlowPosition;
        standItem.contentShowRowsSort = stand.contentShowRowsSort;
        standItem.sceneGroupId = stand.sceneGroupId;
        standItem.sceneId = stand.sceneId;
        standItem.isYyz = stand.isYyz;
        standItem.contentWzUrl = stand.contentWzUrl;
        standItem.contentDsfWzUrl = stand.contentDsfWzUrl;
        standItem.subDomain = stand.subDomain;
        standItem.userId = stand.userId;
        standItem.blockDataType = stand.blockDataType;
        standItem.releaseId = stand.releaseId;
        standItem.sign = stand.sign;
        standItem.iframeUrl = stand.iframeUrl;
        standItem.standAllName = '';
        standItem.appName = stand.appName;
        standItem.priceType = stand.priceType;
        standItem.endTime = stand.endTime;
        standItem.discountTypes = stand.discountTypes;
        standItem.changeData= stand.changeData;
        standItem.spellData= stand.spellData;
        standItem.spellText= stand.spellText;
        standItem.giveData= stand.giveData;
        standItem.giveText= stand.giveText;
        standItem.ordinaryPrice= stand.ordinaryPrice;
        standItem.silverPrice= stand.silverPrice;
        standItem.goldprice= stand.goldprice;
        standItem.platinumPrice= stand.platinumPrice;
        standItem.diamondsPrice= stand.diamondsPrice;
        standItem.blackGoldprice= stand.blackGoldprice;
        standItem.memberEndTime= stand.memberEndTime;

        //ZJ同屏所需参数
        standItem.meetingId = stand.meetingId;
        //同屏直播所需参数
        standItem.communicationId = stand.communicationId;
        standItem.standList = [];
        standItem.standAllTag = [];


        //设置默认类型数据
        var live = {
          type: 'lives',
          name: '默认直播',
          data: this.getDefaultBalueByType(11)
        };

        var video = {
          type: 'videos',
          name: '默认短视频',
          data: this.getDefaultBalueByType(1)
        };

        var image = {
          type: 'images',
          name: '默认图片',
          data: this.getDefaultBalueByType(2)
        };

        // var gif = {
        //     type:'gifs',
        //     name:'默认动图',
        //     data: this.getDefaultBalueByType(12)
        // };

        var article = {
          type: 'article',
          name: '默认文字',
          data: this.getDefaultBalueByType(16)
        };

        var file = {
          type: 'files',
          name: '默认文件',
          data: this.getDefaultBalueByType(4)
        };

        var cmsknow = {
          type: 'cmsknows',
          name: '默认知道',
          data: this.getDefaultBalueByType(17)
        };

        var opetrain = {
          type: 'opetrains',
          name: '默认培训',
          data: this.getDefaultBalueByType(15)
        };



        var aidevice = {
          type: 'aidevices',
          name: '默认设备',
          data: this.getDefaultBalueByType(13)
        };

        var texts = {
          type: 'texts',
          name: '默认文字',
          data: this.getDefaultBalueByType('20')
        };

        // var defaults = {
        //   type: 'defaults',
        //   name: '默认文字',
        //   data: require('../../assets/image/images/defaultImg.png')
        // };



        var tagsAlowList = [];
        var tagsAllEmptys = true;
        var videoImage = stand.standardJson.filter(tag => tag.standardEnName == 'videoShow' && tag.standardData || tag.standardEnName == 'VideoCover' && tag.standardData),imageL,videoL;
        if(videoImage.length > 1){
          imageL = videoImage.filter(tag => tag.fileTypeDetail == '2');
          videoL = videoImage.filter(tag => tag.fileTypeDetail == '1');
        }
        
        stand.standardJson.map((tag) => {
          let typeName = this.getMapNameByType(tag.fileTypeDetail);

          let typeValue = this.getDefaultBalueByType(tag.fileTypeDetail);
          if (typeName == 'lives' && tag.standardData) {
            live.data = '';
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('lives');
            }
          } else if (typeName == 'videos' && tag.standardData) {
            video.data = tag.standardData;
            if(imageL&&imageL.length){
              video.image = imageL[0].standardData;
            }
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('videos');
            }
          } else if (typeName == 'images' && tag.standardData) {
            image.data = tag.standardData;
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('images');
            }
          }
          // else if(typeName=='gifs'&&tag.standardData){
          //     image.data = tag.standardData;
          //     if(tag.standardData){
          //         this.tagsAllEmpty = false;
          //         tagsAlowList.push('gifs');
          //     }
          // }
          else if (typeName == 'article' && tag.standardData) {
            // article.data = tag.standardData;
            article.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('articles');
            }
          } else if (typeName == 'files' && tag.standardData) {
            // file.data = tag.standardData;
            file.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('files');
            }
          } else if (typeName == 'cmsknows' && tag.standardData) {
            // cmsknow.data = tag.standardData;
            cmsknow.data = tag.standardData;

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('cmsknows');
            }
          } else if (typeName == 'opetrains' && tag.standardData) {
            // opetrain.data = tag.standardData;
            opetrain.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('opetrains');
            }
          } else if (typeName == 'aidevices' && tag.standardData) {
            // aidevice.data = tag.standardData;
            aidevice.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('aidevices');
            }
          } else if (typeName == 'texts' && tag.standardData) {
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('texts');
            }
          }

          if (tag.fileTypeDetail == '' && tag.standardData && standItem.standAllName == '') {
            standItem.standAllName = tag.standardData;
            tagsAllEmptys = false;
          }

          standItem.standAllTag.push({
            name: tag.standardName,
            data: tag.standardData ? tag.standardData : typeValue,
            standardEnName : tag.standardEnName
          })

        })
        
        // if(!stand.standardJson.length){
        //     this.tagsAllEmpty = true;
        // }
        if (tagsAllEmptys) {
          // standItem.standList.push(defaults);
          this.tagsAllEmpty = true
        } else {
          allContent = true;
          if (tagsAlowList.indexOf('lives') > -1) {
            standItem.standList.push(live);
          }
          else if (tagsAlowList.indexOf('videos') > -1) {
            standItem.standList.push(video);
          }
          else if (tagsAlowList.indexOf('images') > -1) {
            standItem.standList.push(image);
          }
          else if (tagsAlowList.indexOf('articles') > -1) {
            standItem.standList.push(article);
          }
          else if (tagsAlowList.indexOf('files') > -1) {
            standItem.standList.push(file);
          }
          else if (tagsAlowList.indexOf('cmsknows') > -1) {
            standItem.standList.push(cmsknow);
          }
          else if (tagsAlowList.indexOf('opetrains') > -1) {
            standItem.standList.push(opetrain);
          }
          else if (tagsAlowList.indexOf('aidevices') > -1) {
            standItem.standList.push(aidevice);
          }
          else if (tagsAlowList.indexOf('texts') > -1) {
            standItem.standList.push(texts);
          }
        }

        return standItem;
      })
      if (!allContent) {
        let standItem = {}, array = [];
        standItem.blockId = '';
        standItem.nodeId = '';
        standItem.contentId = '';
        standItem.contentRows = '';
        standItem.contentShowFlowPosition = '';
        standItem.contentShowRowsSort = '';
        standItem.sceneGroupId = '';
        standItem.sceneId = '';
        standItem.isYyz = '';
        standItem.contentWzUrl = '';
        standItem.releaseId = '';
        standItem.sign = '';
        standItem.standAllName = '';
        standItem.appName = '';
        standItem.standList = [];
        standItem.standAllTag = [];
        standItem.standList.push({ type: 'lives', name: '默认直播', data: this.getDefaultBalueByType(11) });
        standItem.standList.push({ type: 'videos', name: '默认短视频', data: this.getDefaultBalueByType(1) });
        standItem.standList.push({ type: 'images', name: '默认图片', data: this.getDefaultBalueByType(2) });
        standItem.standList.push({ type: 'articles', name: '默认文字', data: this.getDefaultBalueByType(16) });
        standItem.standList.push({ type: 'files', name: '默认文件', data: this.getDefaultBalueByType(4) });
        standItem.standList.push({ type: 'cmsknows', name: '默认知道', data: this.getDefaultBalueByType(17) });
        standItem.standList.push({ type: 'opetrains', name: '默认培训', data: this.getDefaultBalueByType(15) });
        standItem.standList.push({ type: 'aidevices', name: '默认设备', data: this.getDefaultBalueByType(13) });
        array.push(standItem);
        this.tagsDataList = array;
      } else {
        this.tagsDataList = tagGrops;
      }
      if(this.tagsDataList[0].standList.length == 8){
        this.tagsDataList[0].standList = this.tagsDataList[0].standList.slice(0,this.preNum);
      }
      
      this.swiperFn();
    },
    swiperFn () {
      let _this = this;
      _this.$nextTick(() => {
        var width = (this.$refs.rightContent.offsetWidth - 20 - (_this.preNum - 1)*20 - 2) / _this.preNum;
        $('.bottom-content' + _this.swiperInd + _this.indexs + ' li').width(width);
      })
    }
  }
}
</script>
<style scoped lang="scss">
.bottom-switch {
  padding: 18px 20px;
  height: 326px;
  overflow: hidden;
  
  .bottom-content {
    position: relative;
    height: 100%;
    overflow: hidden;
    .arrow-left {
      z-index: 9;
      // display: none;
      width: 22px;
      height: 48px;
      position: absolute;
      top: 50%;
      margin-top: -24px;
      left: 0;
      background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
        no-repeat center;
      cursor: pointer;
    }
    .arrow-right {
      z-index: 9;
      width: 22px;
      height: 48px;
      position: absolute;
      top: 50%;
      margin-top: -24px;
      right: 2px;
      background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
        no-repeat center;
      cursor: pointer;
    }
    .arrow-right.show{
      display: block !important;
    }
    // &:hover {
    //   .arrow-left {
    //     display: block;
    //   }
    //   .arrow-right {
    //     display: block;
    //   }
    // }
    ul {
      height: 100%;
      li {
        display: block;
        font-size: 0;
        margin-left: 20px;
        width: 227.25px;
        height: 100%;
        /* line-height: 108px; */
        background: #fafafa;
        /* border: 1px solid#ddd; */
        position: relative;
        > a {
          display: block;
          width: 100%;
          height: 100%;
          // text-align: center;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .li_hover_img{
              position: absolute;
              bottom: 48px;
              right: 0;
              width: 26px;
              height: 20px;
            }
          .li_hover {
            transition: all 0.2s linear;
            width: calc(100% - 20px);
            position: absolute;
            left: 0;
            bottom: 0px;
            background: rgba(0, 0, 0, 0.6);
            padding: 0 10px;
            &:hover ~ .li_hover_img{
              display: none;
            }
            .li_hover_title {
              display:flex;
              flex-direction:column;
              width: 100%;
              margin: 0;
              font-size: 16px;
              color: #fff;
              height: 48px;
              span{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              span:nth-child(1){
                font-size:14px;
                color:rgb(255,255,255);
                padding-top:5px;
              }
              span:nth-child(2){
                font-size:12px;
                color:rgb(170,170,170);
                padding-top:1px;
              }
            }
            .img_right {
              color: #ffffff;
              border: 1px solid #ffffff;
              text-align: center;
              line-height: 18px;
              vertical-align: middle;
              border-radius: 50%;
              height: 18px;
              width: 18px;
              position: absolute;
              top: 10px;
              right: 10px;
              &::after {
                position: absolute;
                content: "";
                border-right: 1px solid #ffffff;
                border-top: 1px solid #ffffff;
                transform: rotate(45deg);
                height: 6px;
                width: 6px;
                top: 5px;
                left: 5px;
              }
            }
            .li_hover_conter {
              border-top: 1px dashed #bbbbbb;
              display: none;
              text-align: left;
              font-size: 14px;
              line-height: 20px;
              margin: 4px 0;
              color: #fff;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 7;
              height: calc(100% - 59px);
              // width: 198px;
              width: 100%;
              overflow: auto;
              .label-box {
                width: 100%;
              }
              .label-set {
                height: 26px;
                line-height: 26px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            &:hover {
              transition: all 0.2s linear;
              height: 100%;
              .li_hover_title {
                padding-top:6px;
              }
              .li_hover_conter {
                display: block;
              }
            }
          }
        }
      }
    }
    // 树形菜单
    .watch {
      width: 100%;
      max-height: 100%;
      overflow: hidden;
      line-height: 32px;
      .version {
        font-size: 14px;
        width: 100%;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .multistage-left {
        padding-right: 18px;
        width: 282px;
        height: 324px;
        overflow: auto;
      }
      .blue-right {
        padding-left: 18px;
        width: 228px;
        height: 324px;
        overflow: auto;
      }
      .blue-right .version a:hover {
        background-color: #fafafa;
      }
      .blue-right a {
        color: #2f8eed;
        display: block;
        height: 32px;
        width: 100%;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .black-center {
        padding: 0 16px;
        border-left: 1px dashed #ddd;
        border-right: 1px dashed #ddd;
        width: calc(100% - 580px);
        height: 324px;
        overflow: auto;
      }
    }
    .no-data {
      color: #999999;
      font-size: 16px;
      text-align: center;
      margin-top: 20px;
    }
    .no-data.white {
      color: #fff;
      font-size: 12px;
      text-align: left;
      margin-top: 0px;
    }
  }
  //企业简介样式
  &.companyIntroduce {
    .bottom-content {
      overflow: hidden auto;
      ul {
        li {
          border: none;
          > a {
            position: relative;
            clear: both;
            width: 100%;
            img {
              float: left;
              width: 50%;
            }
            video {
              float: left;
              width: 50%;
            }
            .z-image {
              float: left;
              width: 50%;
            }
            .linear-gradient {
              float: left;
              width: 50%;
            }
            .li_hover {
              width: calc(50% - 40px);
              background: #fff;
              float: left;
              position: static;
              padding: 0 20px;
              .li_hover_title {
                color: #333333;
              }
              .li_hover_conter {
                color: #333333;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  &.banner {
    .bottom-content {
      ul {
        li {
          border: none;
          > a {
            .li_hover {
              display: none;
            }
          }
        }
      }
    }
  }
}

.flow-arch .right-content .bottom-switch .bottom-content ul li {
  height: 260px;
}
/* .flow-arch .right-content .bottom-switch .bottom-content ul li>a .li_hover{
    bottom:-222px;
} */
.flowArchShow
  .right-content
  .bottom-switch
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: 0px;
}
.flow-arch
  .right-content
  .bottom-switch.flowArchShow
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: 0px;
}
.live-main .right-content .bottom-switch.lives-type {
  height: 254px;
}
.live-main .right-content .bottom-switch.lives-type .bottom-content ul li {
  height: 254px;
}
.live-main
  .right-content
  .bottom-switch.lives-type
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: -214px;
}
.live-main
  .right-content
  .bottom-switch.lives-type
  .bottom-content
  ul
  li
  > a
  .li_hover:hover {
  bottom: 0px;
}
</style>
<style lang="scss" scoped>
.bottom-content ul li {
  background-color: #fff !important;
  border: none !important;
}
.right-content .bottom-switch.flowArchShow {
  padding: 0px;
}
.right-content
  .bottom-switch.flowArchShow
  .bottom-content
  ul
  li
  > a
  .li_hover
  .li_hover_conter {
  height: 188px;
}
@media screen   and (max-width: 768px) {
  .right-content .bottom-switch {
    height: 230px;
    margin-top: -10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/floorBlock/baseGroup.vue